import { decodeToken } from "react-jwt";

const JWTStorageName = "jwt";

export function setJWT(jwt) {
  localStorage.setItem(JWTStorageName, jwt);
}

export function getJWT() {
  return localStorage.getItem(JWTStorageName);
}

export function removeJWT() {
  localStorage.removeItem(JWTStorageName);
}

export function getJWTUsername() {
  let jwt = getJWT();
  let decodedToken = decodeToken(jwt);
  return decodedToken.Username;
}

export function jwtIsValid() {
  let jwt = getJWT();
  let dateNow = new Date();
  let decodedToken = decodeToken(jwt);

  if (decodedToken === null) {
    return false;
  }

  return decodedToken.exp < dateNow.getTime()
}
